import React from 'react';

import Accordion from 'components/Accordion';
import RadioButton from 'components/DesignSystem/RadioButton';
import TitleSemiBold from 'components/Typography/TitleSemiBold';
import { TipoRodada, OpcaoSelect } from 'helper/windx';

interface RunTypeProps {
  opcoes: OpcaoSelect<TipoRodada>[];
  // WINDX-056: `undefined` no boot do WEOL-SH (sem default) — nenhum radio
  // marcado ate o usuario escolher. `checked={valor === opt.id}` ja lida com
  // undefined (todas falsas).
  valor: TipoRodada | undefined;
  onChange: (valor: TipoRodada) => void;
}

export default function RunType({ opcoes, valor, onChange }: RunTypeProps) {
  return (
    <Accordion.Item eventKey="run-type">
      <Accordion.Header>
        <TitleSemiBold>Tipo de Rodada</TitleSemiBold>
      </Accordion.Header>
      <Accordion.Body>
        {opcoes.map((opt) => (
          <RadioButton
            key={opt.id}
            id={`windx-tipo-rodada-${opt.id}`}
            name="windx-tipo-rodada"
            label={opt.label}
            checked={valor === opt.id}
            onChange={() => onChange(opt.id)}
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
